 <div hidden [innerHtml]="appDetails"></div>
 <router-outlet></router-outlet>
